import * as types from './constants';


export function sendFeedbackQuery({ payload, sendFeedbackApi }) {
    return {
        type: types.SEND_FEEDBACK_REQUEST,
        payload,
        sendFeedbackApi
    };
}